module.exports = __webpack_public_path__ + "media/src/images/apple_icon-851f5c76136b4e325db79712cd5fd6ab.png";